import * as React from 'react'
import styled from 'styled-components'
import { paymentDetailService } from 'core/services'
import { InputText, Button } from 'components/atoms'
import { IPaymentDetail, IWindow } from 'static/interfaces'

declare var window: IWindow

interface IProps {
  paymentDetail: IPaymentDetail
  refetchWeeklyTour: () => void
}

export const PaymentDetailModal: React.VFC<IProps> = ({ paymentDetail, refetchWeeklyTour }) => {
  const [otherFee, setOtherFee] = React.useState<number>(paymentDetail.other_fee || 0)
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false)

  const handleSubmit = React.useCallback(async () => {
    if (isSubmitting) {
      return
    }

    setIsSubmitting(true)
    try {
      const { flush } = await paymentDetailService.update({
        id: paymentDetail.id,
        other_fee: otherFee,
      })
      refetchWeeklyTour()
      window.flashMessages?.addMessage({ text: flush.message, type: flush.type })
      window.globalModal.closeModal()
    } catch (e) {
      console.error(e)
    } finally {
      setIsSubmitting(false)
    }
  }, [paymentDetail, refetchWeeklyTour, otherFee])

  return (
    <ModalBodyWrapper>
      <div className="field">
        <InputText
          name="other_fee"
          type="number"
          value={otherFee}
          onChangeHandler={e => setOtherFee(Number(e.target.value) || 0)}
        />
      </div>
      <div className="buttons">
        <Button handleClick={handleSubmit} primary={true} disabled={isSubmitting}>
          {isSubmitting ? '保存中...' : '保存'}
        </Button>
        <Button handleClick={() => window.globalModal.closeModal()} disabled={isSubmitting}>
          キャンセル
        </Button>
      </div>
    </ModalBodyWrapper>
  )
}

const ModalBodyWrapper = styled.div`
  .field {
    margin-bottom: 20px;

    .label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
      color: #333;
    }

    .value {
      font-size: 16px;
      color: #666;
      padding: 8px 0;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    gap: 12px;

    button {
      width: 150px;
    }
  }
`
